/* eslint-disable  */
import {
  Close,
  DashboardOutlined,
  FavoriteBorderOutlined,
  LiveHelp,
  Lock,
  Message,
  MoneyOutlined,
  Person,
  Receipt,
  Security,
  Settings,
  SettingsApplicationsOutlined,
} from "@material-ui/icons";

import React, { useEffect, useState } from "react";
import { BsBasketFill, BsCalculator } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import {
  GiPayMoney,
  GiReceiveMoney,
  GiShoppingCart,
  GiTakeMyMoney,
} from "react-icons/gi";
import { GoListUnordered } from "react-icons/go";
import { SiGooglemessages } from "react-icons/si";
import { TiShoppingCart } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import "../../../../css/Dashboard/home/Home.css";
import { navigationActionCreators } from "../../../../service/action-creators";
import { FaGlobe, FaSlack, FaWpforms, FaFileInvoiceDollar } from "react-icons/fa";
import Modal from "../../../Modal/Modal";

function SideBarMenu() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const navigation = useSelector((state) => state.navigation.openSideNav);
  const messages = useSelector((state) => state?.messages);
  const user = useSelector((state) => state.user);

  const device = () => {
    return window.innerWidth < 1080;
  };
  const [isMobile, setIsMobile] = useState(device);
  const [openLoanRestriction, setOpenLoanRestriction] = useState(false);
  const [loanRestrictionMessage, setLoanRestrictionMessage] = useState("");

  const { closeSideBarOnMobile } = bindActionCreators(
    navigationActionCreators,
    dispatch
  );

  // Function to check if user can apply for a new loan
  const canApplyForLoan = () => {
    if (!user?.myAppliedLoans || user.myAppliedLoans.length === 0) {
      return { canApply: true, message: "" };
    }

    // Check for loans that are not rejected or paid
    const restrictiveLoan = user.myAppliedLoans.find((loan) => {
      return loan.status !== "rejected" && loan.status !== "paid";
    });

    if (restrictiveLoan) {
      let message = "";

      // Customize message based on current loan status
      switch (restrictiveLoan.status) {
        case "submitted":
          message =
            "You have already submitted a loan application. Please wait for it to be processed.";
          break;
        case "booked":
          message =
            "Your loan application has been booked. Please wait for further processing.";
          break;
        case "initiated":
          message = "Your loan has been initiated. Please wait for completion.";
          break;
        case "authorized":
          message =
            "Your loan has been authorized. Please wait for disbursement.";
          break;
        default:
          message = `You have an active loan application with status: ${restrictiveLoan.status}. Please wait for it to be completed or contact support.`;
      }

      return {
        canApply: false,
        message: message,
      };
    }

    return { canApply: true, message: "" };
  };
  // Function to check if user can place a new order
  // const canPlaceOrder = () => {
  //   if (!user?.orders || user.orders.length === 0) {
  //     return { canApply: true, message: "" };
  //   }

  //   // Check for any active (non-rejected, non-delivered) orders
  //   const restrictiveOrder = user.orders.find((order) => {
  //     return order.status !== "rejected" && order.status !== "shipped";
  //   });

  //   if (restrictiveOrder) {
  //     const message = `You already have an order with status: ${restrictiveOrder.status}. Please wait until it's processed.`;
  //     return {
  //       canApply: false,
  //       message,
  //     };
  //   }

  //   return { canApply: true, message: "" };
  // };

  // Handle loan application click
  const handleLoanApplicationClick = (e) => {
    e.preventDefault();
    const loanCheck = canApplyForLoan();

    if (loanCheck.canApply) {
      history.push("/apply-loan-personal_info");
    } else {
      setLoanRestrictionMessage(loanCheck.message);
      setOpenLoanRestriction(true);
    }
  };

  const handleOrderClick = (e) => {
    // e.preventDefault();
    // const orderCheck = canPlaceOrder();

    // if (orderCheck.canApply) {
    history.push("/upnmg-shopping-mall");
    // } else {
    //   setLoanRestrictionMessage(orderCheck.message);
    //   setOpenLoanRestriction(true);
    // }
  };

  useEffect(() => {
    const handler = () => setIsMobile(device);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  // The panel slides over the page on small screens, so it closes the way an
  // overlay is expected to: on Escape, on a tap outside it, and as soon as a
  // link takes you somewhere. Without the last one it stayed open on top of
  // the page you had just navigated to.
  const isOpen = isMobile && navigation;

  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeSideBarOnMobile();
    };
    window.addEventListener("keydown", onKeyDown);

    // Stops the page behind the panel from scrolling under your finger.
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  useEffect(() => {
    if (navigation) closeSideBarOnMobile();
  }, [location.pathname]);

  return (
    <>
      {isOpen && (
        <div
          className="SideBarBackdrop"
          onClick={() => closeSideBarOnMobile()}
          aria-hidden="true"
        />
      )}

      <div
        className={`SideBarMenu${isOpen ? " is-open" : ""}`}
        style={{
          background:
            "url(/images/dev/background.jpg) no-repeat center center/cover",
        }}
      >
        <div className="overlay">
          <div className="title_nd_closeBtn">
            <div className="sideBrand">
              <span className="sideBrand-mark">UP</span>
              <div>
                <p className="sideBrand-name">Nurses Portal</p>
                <p className="sideBrand-sub">UPNMG</p>
              </div>
            </div>
            {/* Only an overlay can be closed — on desktop the panel is the layout. */}
            {isMobile && (
              <button
                type="button"
                className="sideClose"
                onClick={() => closeSideBarOnMobile()}
                aria-label="Close menu"
              >
                <Close style={{ fontSize: "1.2rem" }} />
              </button>
            )}
          </div>
          <ul>
            <NavLink exact className="sideLink" activeClassName="sideLink-active" to="/home">
              <div className="icon">
                <DashboardOutlined />
              </div>
              <div>Dashboard</div>
            </NavLink>

            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/loans"}>
              <div className="icon">
                <GiTakeMyMoney size={20} />
              </div>

              <div>Loans Deduction</div>
            </NavLink>
            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/mart-deduction"}>
              <div className="icon">
                <MoneyOutlined size={20} />
              </div>
              <div>Mart Deduction</div>
            </NavLink>

            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/fund"}>
              <div className="icon">
                <GiPayMoney size={20} />
              </div>
              <div>My Contributions</div>
            </NavLink>

            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/fund-increment"}>
              <div className="icon">
                <GiPayMoney size={20} />
              </div>
              <div>Increase / Decrease Fund</div>
            </NavLink>

            <NavLink
              exact
              className="sideLink"
              activeClassName="sideLink-active"
              to={"/apply-loan-personal_info"}
              onClick={handleLoanApplicationClick}
              style={{ cursor: "pointer" }}
            >
              <div className="icon">
                <GiReceiveMoney size={20} />
              </div>
              <div>Apply Loan</div>
            </NavLink>

            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/my-applied-loans"}>
              <div className="icon">
                <GoListUnordered className="" size={20} />
              </div>
              <div>My applied Loans</div>
            </NavLink>
            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/profile"}>
              <div className="icon">
                <CgProfile size={20} />
              </div>
              <div>My Profile</div>
            </NavLink>

            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/upnmg-shopping-mall"} onClick={handleOrderClick}>
              <div className="icon">
                {/* <ShoppingBasketOutlined /> */}
                <TiShoppingCart size={20} />
              </div>
              <div>UPNMG Mart</div>
            </NavLink>
            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/my-orders-and-purchase"}>
              <div className="icon">
                <FaWpforms className="" size={20} />
              </div>
              <div>My Orders </div>
            </NavLink>
            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/favourites"}>
              <div className="icon">
                <FavoriteBorderOutlined className="" size={20} />
              </div>
              <div>My Favourites</div>
            </NavLink>
            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/my-cart"}>
              <div className="icon">
                <GiShoppingCart size={20} />
                {/* <ShoppingBasketOutlined /> */}
              </div>
              <div>My Cart</div>
            </NavLink>

            {/* TODO:: WE HAVE HIDE THE REQUESTED FOR FUTURE UPDATES */}
            {/* <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/request-order"}>
              <div className="icon">
                <FaSlack className="" size={20} />
              </div>
              <div>Request Order </div>
            </NavLink> */}

            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/message"}>
              <div className="icon">
                <SiGooglemessages className="" size={20} />
              </div>
              <div>Messenger ({`${messages?.unreadMessagesTotal}`})</div>
            </NavLink>
            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/calculator"}>
              <div className="icon">
                <BsCalculator className="" size={20} />
              </div>
              <div>Loan Calculator</div>
            </NavLink>

            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/request-settlement"}>
              <div className="icon">
                <FaFileInvoiceDollar size={20} />
              </div>
              <div>Request Settlement</div>
            </NavLink>

            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/my-settlement-quotation"}>
              <div className="icon">
                <Receipt size={20} />
              </div><div>Settlement Quotation</div>
            </NavLink>
            <hr />

            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/settings"}>
              <div className="icon">
                <Settings size={20} />
              </div>
              <div>Settings</div>
            </NavLink>
            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/faq"}>
              <div className="icon">
                <LiveHelp size={20} />
              </div>
              <div>
                FAQ<small>s</small>
              </div>
            </NavLink>
            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/privacy-policy"}>
              <div className="icon">
                <Security size={20} />
              </div>
              <div>Privacy Policy</div>
            </NavLink>
            <a href="https://upnmg.com" target="_blank" rel="noreferrer" className="sideLink">
              <div className="icon">
                <FaGlobe />
              </div>
              <div>UPNMG WEBSITE</div>
            </a>

            <NavLink exact className="sideLink" activeClassName="sideLink-active" to={"/logout"}>
              <div className="icon">
                <Lock size={20} />
              </div>
              <div>Logout</div>
            </NavLink>
          </ul>
        </div>
      </div>

      {/* Loan Restriction Modal */}
      {openLoanRestriction && (
        <Modal
          title={"Loan Application Restricted"}
          width={isMobile ? "85%" : "35%"}
          closeModal={setOpenLoanRestriction}
        >
          <div className="modalBody">
            <div className="text-center">
              <p>{loanRestrictionMessage}</p>
            </div>
          </div>
          <div className="modalButton">
            <div className="btnCover">
              <button
                type="button"
                onClick={() => setOpenLoanRestriction(false)}
                className="modalBtn"
              >
                OK
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}

export default SideBarMenu;
